// These error codes match cordova-advanced-http, version 1.11.1
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["Generic"] = -1] = "Generic";
    ErrorCode[ErrorCode["UnknownHost"] = 0] = "UnknownHost";
    ErrorCode[ErrorCode["Timeout"] = 1] = "Timeout";
})(ErrorCode || (ErrorCode = {}));
export const requestMethods = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete',
    'options',
    'upload',
    'download',
];
export function isRequestMethod(value) {
    return requestMethods.some(m => m === value);
}
